import React, {createContext, ReactNode, useContext, useEffect, useState} from "react";
import {SystemControllerApi, SystemDto} from "../../api";
import {message} from "antd";
import {useKeycloakHeader} from "../../config/Config";

// Context-Typ definieren
interface SystemContextType {
    systems: SystemDto[];
    triggerRefresh: () => void;
}

export const SystemContext = createContext<SystemContextType | null>(null);

export const SystemProvider = ({ children }: { children: ReactNode }) => {
    const [refresh, setRefresh] = useState(0);
    const [systems, setSystems] = useState<SystemDto[]>([]);

    const headers = useKeycloakHeader();

    const systemControllerApi = new SystemControllerApi();

    useEffect(() => {
        fetchSystems();
    }, [refresh]);

    const triggerRefresh = () => {
        setRefresh(prev => prev + 1);
    };

    const fetchSystems = () => {
        systemControllerApi.getAllSystems(headers)
            .then(response => {
                const data: SystemDto[] = response.data;
                setSystems(data);
            })
            .catch(error => {
                if(error.response && error.response.status !== 401){
                    message.error("Es konnten keine Systeme geladen werden!");
                }
            })
    }

    return (
        <SystemContext.Provider value={{ systems, triggerRefresh }}>
            {children}
        </SystemContext.Provider>
    );
};

export const useSystemContext = () => {
    const context = useContext(SystemContext);

    if (!context) {
        throw new Error("useSystemContext muss innerhalb eines SystemProviders verwendet werden!");
    }

    return context;
};
